<div class="logout">
  <div class="logout-message">
    <p class="logout-title">
      {{
        loggedIn
          ? ('APP.SIGN_OUT.MESSAGE.LOGGED_IN.MESSAGE' | translate)
          : ('APP.SIGN_OUT.MESSAGE.SUCCESS' | translate)
      }}
    </p>
    <p *ngIf="!loggedIn">{{ 'APP.SIGN_OUT.MESSAGE.ACTIONS' | translate }}</p>
  </div>
  <div class="logout-actions">
    <div class="logout-actions-buttons">
      <button
        *ngIf="!loggedIn"
        class="logout-actions-buttons-button wk-button"
        (click)="login()"
      >
        {{ 'APP.SIGN_OUT.LOG_IN' | translate }}
      </button>
      <button
        *ngIf="loggedIn"
        class="logout-actions-buttons-loggedin wk-button"
        (click)="navigateToDashboard()"
      >
        {{ 'APP.SIGN_OUT.MESSAGE.LOGGED_IN.DASHBOARD' | translate }}
      </button>
    </div>
  </div>
</div>
